import { z } from "zod";
/** "true"/"false" dizgesini boolean'a çevirir (ortam değişkenleri için). */
export const envBoolean = (defaultValue) => z
    .enum(["true", "false"])
    .default(defaultValue ? "true" : "false")
    .transform((value) => value === "true");
/** Virgülle ayrılmış listeyi diziye çevirir. */
export const envList = z
    .string()
    .default("")
    .transform((value) => value
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item.length > 0));
export class EnvValidationError extends Error {
    issues;
    constructor(issues) {
        super(`Geçersiz ortam yapılandırması:\n${issues.map((issue) => `  - ${issue}`).join("\n")}`);
        this.issues = issues;
        this.name = "EnvValidationError";
    }
}
/**
 * Ortam değişkenlerini Zod şemasıyla doğrular (AGENTS.md §3.11).
 * Boş dizge "tanımsız" sayılır; böylece `.env` içindeki `KEY=` satırları varsayılanı devreye sokar.
 */
export function parseEnv(schema, source) {
    const cleaned = Object.fromEntries(Object.entries(source).filter(([, value]) => value !== ""));
    const result = schema.safeParse(cleaned);
    if (!result.success) {
        throw new EnvValidationError(result.error.issues.map((issue) => `${issue.path.join(".") || "(kök)"}: ${issue.message}`));
    }
    return result.data;
}
/** Doğrulama hatasında okunur mesajı yazıp süreci sonlandırır; süreç giriş noktalarında kullanılır. */
export function loadEnvOrExit(schema, source = process.env) {
    try {
        return parseEnv(schema, source);
    }
    catch (error) {
        if (error instanceof EnvValidationError) {
            console.error(error.message);
            process.exit(1);
        }
        throw error;
    }
}
//# sourceMappingURL=env.js.map